<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    let {
        currentChoices = null,
        value = $bindable(),
        name = null,
        dependsOn,
        label,
        placeholder,
        defaultValue,
        horizontal = false,
        choices,
        values = $bindable(),
    }: FieldComponentProps = $props()
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $derived(dependsOn ? ruleEngine.resolve(dependsOn, values) : true)

    if (!value) {
        value = defaultValue
        if (currentChoices && currentChoices[name] && value !== currentChoices[name]) {
            value = currentChoices[name]
        }
    }

    $effect(() => {
        if (!displayComponent) value = null
        else if (!value && defaultValue) value = defaultValue
    })
</script>

{#if displayComponent}
    <div class="radio-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <div class="radio-input-choices" class:horizontal>
            {#each choices as choice}
                <label for="{name}_{choice.title}" class="radio-input-choice">
                    <input
                        type="radio"
                        id="{name}_{choice.title}"
                        name="{name}_{choice.title}"
                        bind:group={value}
                        value={choice.id}
                        {placeholder}
                    />
                    <span>{choice.title}</span>
                </label>
            {/each}
        </div>
    </div>
{/if}
